export default function LocationMarkerIcon() {
  return (
    <svg
      aria-hidden="true"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1C13.866 1 17 4.00233 17 7.70588C17 11.6176 10.8167 19.5418 10.8167 19.5418C10.6308 19.805 10.3306 19.9734 10 20C9.67813 19.9729 9.38242 19.8191 9.18333 19.5753C9.18333 19.5753 3 11.6176 3 7.70588C3.04412 4.01998 6.15243 1.04227 10 1ZM12.6132 7.56029C12.626 6.16356 11.4579 5.01964 10 5.00118C8.529 4.99497 7.3295 6.12908 7.31667 7.53824C7.31679 8.93502 8.49545 10.069 9.95349 10.075C11.4115 10.0811 12.6004 8.95703 12.6132 7.56029Z"
        fill="#ffffff"
      />
    </svg>
  );
}
